import { useQuery } from 'react-query';
import { getCampuses } from '../services/users'

export const useCampusList = () => {
  const result = useQuery(`campusList`, async () =>
    getCampuses()
  );
  return { ...result, data: result?.data?.data };
};
